import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_shield",
  "use": "icon-icon_shield-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_shield\">\n    <path d=\"M12 1L3 5C3 5 3 9 3 11C3 18.83 9.439 22.486 12 23C14.561 22.486 21 18.83 21 11C21 9 21 5 21 5L12 1ZM19 11C19 17.134 14.215 20.254 12 20.937C9.785 20.254 5 17.134 5 11V6.3L12 3.189L19 6.3V11Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol